import { Context } from '@/app/common/starTrack/events/utils/starTrack.types';

export const FLIGHT_DETAILS_OPENED = 'FLIGHT_DETAILS_OPENED';
export const FLIGHT_DETAILS_OPENED_VERSION = '1.0';

export type FlightDetailsOpenedPayload = {
  searchId: string;
  productDetailKey: string;
  context: string;
};

export type FlightDetailsOpenedParams = {
  searchId: string;
  productDetailKey: string;
  context?: Context;
};

export const createFlightDetailsOpenedPayload = (params: FlightDetailsOpenedParams): FlightDetailsOpenedPayload => {
  const { searchId, productDetailKey, context = Context.hotelDetail } = params;

  return {
    searchId,
    productDetailKey,
    context,
  };
};
